module.exports = __webpack_public_path__ + "images/insights-board-fe1d7df5.svg";